import { RegisterMobilePushEndpointPersonPlatformEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import { APNS_PUSH_PLATFORM } from '@/constants/app';
import { isAndroid } from '@/shared/utils/platform';

export const PUSH_PLATFORM = isAndroid
  ? RegisterMobilePushEndpointPersonPlatformEnum.Fcm
  : APNS_PUSH_PLATFORM;
